var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraBam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9979 13.4644L21.7978 15.6235C21.5928 14.0435 20.2338 12.8242 18.5877 12.8242H4.30043C2.51232 12.8242 1.0625 14.2646 1.0625 16.0411V23.505C1.0625 25.2815 2.51232 26.7219 4.30043 26.7219H18.5877C20.3758 26.7219 21.8257 25.2815 21.8257 23.505V23.5006L25.9979 25.443V13.4644Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4359 1.00006C17.8976 1.01316 19.8995 2.99771 19.9142 5.43911C19.9288 7.89216 17.8771 9.91163 15.3861 9.89708C12.9316 9.88253 10.9238 7.87761 10.9297 5.44348C10.9341 2.9948 12.9712 0.986969 15.4373 1.00006H15.4359Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30469 6.32696C1.30762 4.35114 2.92292 2.75652 4.90873 2.76961C6.88722 2.78271 8.47617 4.37442 8.47324 6.3386C8.47031 8.30424 6.87258 9.89159 4.89702 9.89304C2.90095 9.89304 1.30322 8.30569 1.30469 6.32551V6.32696Z",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraBam);
export default __webpack_public_path__ + "static/media/camera-bam.9260d86a8134c6043c54588743d6690d.svg";
export { ForwardRef as ReactComponent };